const Footer = () => {
    return (
      <div
        style={{
          textAlign: "center",
          marginBottom: 10,
        }}
      >
        Made by SCoder7
      </div>
    );
  };
  
  export default Footer;
  